<template>
	<v-container
		:fluid="fluid"
		v-bind="$attrs"
		v-on="$listeners">
		<slot/>
	</v-container>
</template>

<script>
export default {
	name: 'KContainer',
	inheritAttrs: false,
	props: {
		fluid: {
			type: Boolean,
			default: false
		}
	}
}
</script>